import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "Deutsch",
  code: "de",
  messages: {
    alert: {
      close: "Schlie\xDFen"
    },
    authForm: {
      hidePassword: "Passwort verbergen",
      showPassword: "Passwort anzeigen",
      submit: "Weiter"
    },
    banner: {
      close: "Schlie\xDFen"
    },
    calendar: {
      nextMonth: "N\xE4chster Monat",
      nextYear: "N\xE4chstes Jahr",
      prevMonth: "Vorheriger Monat",
      prevYear: "Vorheriges Jahr"
    },
    carousel: {
      dots: "Folie zur Anzeige ausw\xE4hlen",
      goto: "Gehe zu {slide}",
      next: "Weiter",
      prev: "Zur\xFCck"
    },
    chatPrompt: {
      placeholder: "Hier schreiben Sie Ihre Nachricht..."
    },
    chatPromptSubmit: {
      label: "Senden"
    },
    colorMode: {
      dark: "Dunkel",
      light: "Hell",
      switchToDark: "Zum dunklen Modus wechseln",
      switchToLight: "Zum hellen Modus wechseln",
      system: "System"
    },
    commandPalette: {
      back: "Zur\xFCck",
      close: "Schlie\xDFen",
      noData: "Keine Daten",
      noMatch: "Nichts gefunden",
      placeholder: "Geben Sie einen Befehl ein oder suchen Sie..."
    },
    contentSearch: {
      links: "Links",
      theme: "Thema"
    },
    contentSearchButton: {
      label: "Suchen..."
    },
    contentToc: {
      title: "Auf dieser Seite"
    },
    dashboardSearch: {
      theme: "Thema"
    },
    dashboardSearchButton: {
      label: "Suchen..."
    },
    dashboardSidebarCollapse: {
      collapse: "Seitenleiste einklappen",
      expand: "Seitenleiste erweitern"
    },
    dashboardSidebarToggle: {
      close: "Seitenleiste schlie\xDFen",
      open: "Seitenleiste \xF6ffnen"
    },
    error: {
      clear: "Zur\xFCck zur Startseite"
    },
    fileUpload: {
      removeFile: "{filename} entfernen"
    },
    header: {
      close: "Men\xFC schlie\xDFen",
      open: "Men\xFC \xF6ffnen"
    },
    inputMenu: {
      create: '"{label}" erstellen',
      noData: "Keine Daten",
      noMatch: "Nichts gefunden"
    },
    inputNumber: {
      decrement: "Verringern",
      increment: "Erh\xF6hen"
    },
    modal: {
      close: "Schlie\xDFen"
    },
    pricingTable: {
      caption: "Preisplanvergleich"
    },
    prose: {
      codeCollapse: {
        closeText: "Reduzieren",
        name: "Code",
        openText: "Erweitern"
      },
      collapsible: {
        closeText: "Ausblenden",
        name: "Eigenschaften",
        openText: "Anzeigen"
      },
      pre: {
        copy: "Code in die Zwischenablage kopieren"
      }
    },
    selectMenu: {
      create: '"{label}" erstellen',
      noData: "Keine Daten",
      noMatch: "Nichts gefunden",
      search: "Suchen..."
    },
    slideover: {
      close: "Schlie\xDFen"
    },
    table: {
      noData: "Keine Daten"
    },
    toast: {
      close: "Schlie\xDFen"
    }
  }
});
